import coreSlice from "./slices/core";
import errorSlice from "./slices/error";
import { modalActions } from "./slices/modal";
import sessionSlice from "./slices/session";
import toastsSlice from "./slices/toasts";

export const commonAppActions = {
  core: coreSlice.actions,
  error: errorSlice.actions,
  modal: modalActions,
  session: sessionSlice.actions,
  toasts: toastsSlice.actions
};
